import { z } from 'zod'
import { rarityEnum } from '@/api/resources/shared/rarity'
import { avatarMediaSchema } from '@/api/resources/shared/avatar'

export const seasonStatusValues = ['current', 'past', 'next'] as const

export const seasonStatusEnum = z.enum(seasonStatusValues)

export const seasonSchema = z.object({
  id: z.number(),
  name: z.string(),
  reward_group_id: z.number(),
  rank_threshold: z.number(),
  points_converted: z.number().nullable(),
  items_converted: z.number().nullable(),
  time_start: z.string(),
  time_end: z.string(),
  season_status: seasonStatusEnum,
  convert_limit: z.number()
})

export const arcadeInventoryRaritySchema = z.record(
  rarityEnum,
  z.object({
    count: z.number(),
    points_available: z.number().optional()
  })
)

export const arcadeInventoryValueSchema = z.object({
  convert_count: z.number(),
  points_available: z.number().optional(),
  rarity: arcadeInventoryRaritySchema
})

export const arcadePlayerMediaSchema = z.object({
  avatar_media: avatarMediaSchema
})

export const arcadeInventorySchema = z.object({
  season: seasonSchema,
  player_join_date: z.string().nullable(),
  player_points: z.number().nullable(),
  player_rank: z.number().nullable(),
  points_to_threshold: z.number(),
  chain_url: z.string(),
  kyc_completed: z.boolean(),
  is_owner: z.boolean(),
  player_media: arcadePlayerMediaSchema,
  arcade_inventory_value: arcadeInventoryValueSchema
})

export const arcadeSettingsResponseSchema = z.object({
  id: z.number(),
  name: z.string(),
  reward_group_id: z.number(),
  rank_threshold: z.string(),
  time_start: z.string(),
  time_end: z.string()
})

export type SeasonStatus = z.infer<typeof seasonStatusEnum>
export type Season = z.infer<typeof seasonSchema>
